import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Label } from "components/bootstrap";
import { Tooltip } from "components/common";
import { DISABLED_MODEL_PROVIDER_EXPLANATION } from "ai-management/model-providers/Constants";
const StyledLabel = styled(Label)`
  margin-left: 5px;
  vertical-align: inherit;
`;
const DisabledLabel = () => {
  const { t } = useTranslation("enterprise_ai");
  return /* @__PURE__ */ React.createElement(Tooltip, { label: t(DISABLED_MODEL_PROVIDER_EXPLANATION), position: "top", multiline: true, w: 300 }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(StyledLabel, { bsStyle: "warning", bsSize: "xsmall" }, t("disabled_label.text"))));
};
export default DisabledLabel;
